function About() {
  return (
    <div className="section">
      <h2>About Our Business</h2>

      <div className="grid">
        <div className="card">
          <h3>Established in 2002</h3>
          <p>
            Over two decades of experience in dairy and frozen product wholesale.
          </p>
        </div>

        <div className="card">
          <h3>Wholesale Traders</h3>
          <p>
            We operate as bulk suppliers fulfilling third-party requirements
            directly from warehouses and manufacturing units.
          </p>
        </div>

        <div className="card">
          <h3>Supply Chain Strength</h3>
          <p>
            Strong sourcing network ensures fresh stock and large volume availability.
          </p>
        </div>

        <div className="card">
          <h3>Service Area</h3>
          <p>
            Serving Noida, Greater Noida, Delhi, Ghaziabad,
            Gurugram & Faridabad.
          </p>
        </div>
      </div>

      <div style={{ marginTop: "60px", maxWidth: "800px", marginInline: "auto" }}>
        <h3>Leadership</h3>
        <p><strong>Founder:</strong> Ganga Prasad Chaudhary</p>
        <p><strong>Co-Founder:</strong> Rishab Jaiswal</p>
      </div>
    </div>
  );
}

export default About;